module.exports = __webpack_public_path__ + "img/myOrder.79392315.png";